import { createAction, createEmptyAction, createMapAction } from "chalet-shared";

import { Data } from "../service/Data";

export class ProtoError<E> {
    constructor(public payload: any, public operation: E) {}
}

interface RenameForumData {
    room_id: string;
    forum_id: string;
    name: string;
}

// TODO: please rename ActionCreators to actionCreators and move to separate files once we no longer use flux

export const actionCreators = {
    JoinRoom: createMapAction("JoinRoom", (x: string) => x),
    LeaveRoom: createMapAction("LeaveRoom", (x: string) => x),

    SetTyping: createMapAction("SetTyping", (x: { room_id: string }) => x),

    CreateForum: createMapAction(
        "CreateForum",
        (x: { name: string; isPrivate: boolean; memberIds: string[] }) => x
    ),
    CreateForumSuccess: createMapAction("CreateForumSuccess", (x: Data.RoomsIn) => x),
    CreateForumError: createMapAction(
        "CreateForumError",
        (x: ProtoError<{ name: string; isPrivate: boolean; memberIds: string[] }>) => x
    ),

    SeenText: createMapAction("SeenText", (x: Data.SeenText) => x),
    SeenAllText: createMapAction("SeenAllText", (x: { room_id: string }) => x),
    MarkTextUnseen: createMapAction("MarkTextUnseen", (x: Data.MarkTextUnseen) => x),

    GetFileURLs: createMapAction(
        "GetFileURLs",
        (x: { id: string; callback: (promise: Promise<Data.FileURLsIn>) => void }) => x
    ),

    ArchiveForum: createMapAction("ArchiveForum", (x: { forum_id: string }) => x),
    RenameForum: createMapAction("RenameForum", (x: RenameForumData) => x),
    RenameForumError: createMapAction("RenameForumError", (x: ProtoError<RenameForumData>) => x),

    ChangeForumAccess: createMapAction(
        "ChangeForumAccess",
        (x: { forum_id: string; memberIds: string[] }) => x
    ),

    // app actions
    RoomInput: createAction("RoomInput", (roomId: string, roomInput: string) => ({
        type: "RoomInput",
        payload: { roomId, roomInput },
    })),

    NewForumName: createAction("NewForumName", (value: string) => ({
        type: "NewForumName",
        payload: { value },
    })),

    ForumNameValue: createAction("ForumNameValue", (roomId: string, value: string) => ({
        type: "ForumNameValue",
        payload: { roomId, value },
    })),

    NewNameOnFocus: createAction("NewNameOnFocus", (roomId: string) => ({
        type: "NewNameOnFocus",
        payload: { roomId },
    })),
    NewNameOnBlur: createAction("NewNameOnBlur", (roomId: string) => ({
        type: "NewNameOnBlur",
        payload: { roomId },
    })),

    ToggleNewForumModalVisible: createEmptyAction("ToggleNewForumModalVisible"),
    ToggleIsNewForumPrivate: createEmptyAction("ToggleIsNewForumPrivate"),

    AddPrivateRoomMember: createAction(
        "AddPrivateRoomMember",
        (roomId: string, userId: string) => ({
            type: "AddPrivateRoomMember",
            payload: { roomId, userId },
        })
    ),
    RemovePrivateRoomMember: createAction(
        "RemovePrivateRoomMember",
        (roomId: string, userId: string) => ({
            type: "RemovePrivateRoomMember",
            payload: { roomId, userId },
        })
    ),

    ToggleSettingAccess: createAction("ToggleSettingAccess", (roomId: string) => ({
        type: "ToggleSettingAccess",
        payload: { roomId },
    })),

    ToggleMediaViewerVisible: createEmptyAction("ToggleMediaViewerVisible"),
    SetMediaViewerContent: createAction(
        "SetMediaViewerContent",
        (id: string, contentUrl: string, uploadData?: Data.UploadData, viewerUrl?: string) => ({
            type: "SetMediaViewerContent",
            payload: { id, contentUrl, uploadData, viewerUrl },
        })
    ),
};
